import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: #bababa;
  height: 100vh;
`;

export const Header = styled.div`
  background-color: black;
  align-items: center;
  vertical-align: center;
  padding: 15px 0;
  display: flex;
  flex-direction: column;
  border-bottom: 3px #fff solid;
`;

export const Logo = styled.img`
  margin: 0 0 5px 15px;
`;

export const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  border: 10px #bababa solid;
  padding: 0;
  background-color: white;
`;

export const AuctionTitle = styled.h1`
  text-align: center;
  font-size: 1.1rem;
  color: #fff;
  font-weight: normal;
  margin: 0;
  align-items: center;
  font-weight: bold;
`;
